import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const ButtonWithIcon = () => {
  return (
    <Button
      type="button"
      className="group relative h-12 w-fit cursor-pointer overflow-hidden rounded-full bg-neutral-950 p-1 ps-6 pe-14 text-sm font-medium text-white"
    >
      <span className="relative z-10">Click to Find out more</span>
      <div className="absolute right-1 flex h-10 w-10 items-center justify-center rounded-full bg-white text-neutral-950">
        <ArrowUpRight size={16} />
      </div>
    </Button>
  );
};

export default ButtonWithIcon;

